import { IDeliveryModalContext } from './model';

export const initialState: IDeliveryModalContext = {
  isOpen: false,
  selectedPickUpPoint: null,
  modalSettings: null,
  webSettings: [],
  initialFilter: null,

  mapListingState: null,
  shouldFetchData: 0,
  previousData: {
    pupsFilter: [],
    mapListingState: null,
  },
  userLocation: null,
  filter: [],
  pickUpPoints: [],
  pickupPointsAreLoading: false,
};
